import React from 'react'
import ReactDom from 'react-dom'

import { Close } from 'components/misc/Icons'

export default function ModalPhoto({ open, onClose, image }) {

    if (!open) return null

    return ReactDom.createPortal(
        <div className="fixed top-0 bottom-0 left-0 right-0 bg-lightbg dark:bg-darkbg" style={{zIndex:"1001"}}>
            <div className="fixed z-50 flex justify-center w-full h-full p-4 rounded bg-bglight dark:bg-bgdark" style={{top: '50%',left: '50%',transform: 'translate(-50%, -50%)'}}>
                <button onClick={onClose} className="absolute top-0 right-0 w-8 h-8 mt-4 mr-4 text-textlight dark:text-textdark focus:outline-none">
                    <Close/>
                </button>
                <img src={image} className="max-w-full max-h-full"alt="ALT"/>
            </div>
        </div>,

        document.getElementById('portal')
    )
}
